import { translateText } from "utils"

export default {
  'Note.TranslateButton': async ({ translated, event, translation, translatedMessage }, _, internalStateSetter) => {
    if (!translation || event.description !== translatedMessage) {
      const translatedText = await translateText(event.description)
      internalStateSetter({ translated: !translated, translation: translatedText, translatedMessage: event.description })
    } else {
      internalStateSetter({ translated: !translated })
    }
  },
  'Note.CancelEdit': async ({ }, _, internalStateSetter) => {
    internalStateSetter({ isEditing: false })
  },
  'Note.NoteBody.Image': ({ url }, outlet) => {
    outlet({ action: 'view_media', url });
  },
  'Note.NoteBody.TopWrapper.ActionsDropdown': ({ action }, _, internalStateSetter) => {
    if (action === 'edit') {
      internalStateSetter({ isEditing: true })
    }
  },
  'Note.NoteInput': ({ mentions, uuids, value, privacy }, outlet, internalStateSetter) => {
    outlet({ action: 'edit', note: { value, mentions, uuids, privacy } });
    internalStateSetter({ isEditing: false })
  }
}